import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
// Models
import { BatteryLogbook, BatteryLogEntry } from '@mocca-technologies/model';

import { BatteryLogbookTemplate } from '../../logbook-templates/battery-logbook-template/battery-logbook-template.component';
import { selectedValues } from '../../logbooks-menu/logbooks-menu.component';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-battery-table',
  templateUrl: './battery-table.component.html',
  styleUrls: ['./battery-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class BatteryTableComponent implements OnInit {

  /**
   * Input variables
   */

  @Input() rows: BatteryLogEntry[];
  @Input() batteryLogbook: BatteryLogbook;
  @Input() selectedValues: selectedValues;

  /**
   * Variables
   */

  columnsBatteryLog = [];

  private destroy$ = new Subject<void>();

  logType = 'Battery';

  constructor(private modalCtrl: ModalController,
              private translateService: TranslateService
  ) {}

  // #region --> LifeCycle Methods

  ngOnInit() {
    this.initColumns();
    
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.initColumns();
      });
  }

  // #endregion --> LifeCycle Methods

  // #region --> Page Methods

  /**
   * Method to open the document visualizer with the battery logbook
   */

  async downloadBatteryLogbook() {

      const modal = await this.modalCtrl.create({
        component: BatteryLogbookTemplate,
        cssClass: 'templateModal',
        componentProps: {
          rows: this.rows,
          batteryLogbook: this.batteryLogbook,
          selectedBattery: this.selectedValues.selectedBattery,
        },
      });
      modal.present();

  }

  private initColumns() {
    this.columnsBatteryLog = [
      { field: 'flightOperationUuid', headerName: 'Flight Operation UUID', filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 180, hide: true },
      { field: 'dateString', headerName: this.translateService.instant('PAGES.LOGBOOKS.BATTERY_LOGBOOK.DATE'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 120 },
      { field: 'takeOffCapacity', headerName: this.translateService.instant('PAGES.LOGBOOKS.BATTERY_LOGBOOK.TAKEOFF_CAPACITY'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 150 },
      { field: 'landingCapacity', headerName: this.translateService.instant('PAGES.LOGBOOKS.BATTERY_LOGBOOK.LANDING_CAPACITY'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 150 },
      { field: 'meanTemperature', headerName: this.translateService.instant('PAGES.LOGBOOKS.BATTERY_LOGBOOK.MEAN_TEMPERATURE'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 150 },
      { field: 'returnToHomeCapacity', headerName: this.translateService.instant('PAGES.LOGBOOKS.BATTERY_LOGBOOK.RTH_CAPACITY'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 150 },
      { field: 'drone', headerName: this.translateService.instant('PAGES.LOGBOOKS.BATTERY_LOGBOOK.DRONE'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 170 },
      { field: 'notes', headerName: 'Notes', filter: true, hide: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 180 },
    ];
  }

  /**
   * Check if current screen is mobile view
   */
  isMobileView(): boolean {
    return window.innerWidth < 600;
  }

  isDesktopView(): boolean {
    return window.innerWidth >= 1024;
  }

}
